import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import WebFont from 'webfontloader';

var useFonts = function useFonts(fonts) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var families = Object.keys(fonts).reduce(function (allFamilies, type) {
    var _fonts$type$families = fonts[type].families,
        typeFamilies = _fonts$type$families === void 0 ? [] : _fonts$type$families;
    return [].concat(_toConsumableArray(allFamilies), _toConsumableArray(typeFamilies));
  }, []).sort();
  useEffect(function () {
    var canceled = false;

    var onFontsActive = function onFontsActive() {
      if (!canceled) {
        setLoaded(true);
      }
    };

    WebFont.load(_objectSpread({}, fonts, {
      active: onFontsActive
    }));
    return function () {
      canceled = true;
    };
  }, _toConsumableArray(families));
  return {
    loaded: loaded
  };
};

export default useFonts;